import { render } from "./NoAccess.vue?vue&type=template&id=16f8e4b6&scoped=true"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"

import "./NoAccess.vue?vue&type=style&index=0&id=16f8e4b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f8e4b6"],['__file',"src/views/login/NoAccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16f8e4b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16f8e4b6', __exports__)) {
    api.reload('16f8e4b6', __exports__)
  }
  
  module.hot.accept("./NoAccess.vue?vue&type=template&id=16f8e4b6&scoped=true", () => {
    api.rerender('16f8e4b6', render)
  })

}


export default __exports__